import { useEffect, useState } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { OutsideClick } from '../../../../../../components/outside-click';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import ModalContent from '../../../../../../components/modal-content';
import { useCreateChatroomMutation } from '../../../../../../slices/inboxApiSlice';
import { useGetAllUsersByRoleQuery } from '../../../../../../slices/userApiSlice';
import { UserRoles } from '../../../../../../utils/constants';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../../../slices/auth';
import { NewChatVSchema } from './schema/new-chat-v-schema';
import { useGetSchoolsByUserStateQuery } from '../../../../../../slices/schoolsApiSlice';

const NewChat = () => {
  const user = useSelector(selectUser);
  const [orgId, setOrgId] = useState<number>(-1);
  const [
    createChatroom,
    { data: createdData, isSuccess: createIsSuccess, isLoading: createIsLoading },
  ] = useCreateChatroomMutation();
  const { data: userData } = useGetAllUsersByRoleQuery({ id: UserRoles.Ogma, params: {} });
  const { data: schoolData } = useGetSchoolsByUserStateQuery({});
  const formInputs = [
    {
      mainTitle: 'Chat Information',
      name: 'name',
      label: 'Subject',
      type: 'name',
      placeholder: 'Enter Chat Subject',
      isTrue: true,
      hidden: false,
    },
    {
      mainTitle: 'Chat Information',
      name: 'school',
      label: 'School',
      isSelect: true,
      placeholder: 'Select School',
      options: [{ id: `0-0`, name: 'Admin Team' }].concat(
        (schoolData ?? []).map((school: any) => {
          return { id: `${school.id}-${school.organization_id}`, name: school.name };
        }),
      ),
      isTrue: true,
      hidden: false,
    },
    {
      mainTitle: 'Chat Information',
      name: 'members',
      label: 'Select One Or More Members',
      type: 'multiSelect',
      groupedOptions: [
        {
          label: 'General Managers',
          options:
            userData
              ?.filter(
                (u: any) =>
                  u.id !== user.id && (!orgId || u.ogma_org.map((o: any) => o.id).includes(orgId)),
              )
              .sort((a: any, b: any) => a.lastName.localeCompare(b.lastName))
              .map((user: any) => {
                return { value: user.id, label: user.firstName + ' ' + user.lastName };
              }) ?? [],
        },
      ],
      selectedValues: [],
      placeholder: 'Select Members',
      isTrue: true,
      hidden: orgId === 0,
    },
  ];
  const initialValues: { [key: string]: string } = {};
  formInputs.forEach((input) => (initialValues[input.name] = ''));

  function handleSubmit(values: any) {
    createChatroom({ body: values });
  }

  useEffect(() => {
    if (createIsSuccess)
      toast.success('Chatroom has been cretead successfully.', { position: 'top-right' });
  }, [createIsSuccess]);

  if (createIsSuccess) {
    return <Navigate to={`../message/${createdData?.id}`} />;
  }

  const newChatSchema = NewChatVSchema();
  return (
    <>
      <OutsideClick />
      <Formik
        enableReinitialize
        validationSchema={newChatSchema}
        initialValues={{ ...initialValues }}
        onSubmit={handleSubmit}
      >
        {({ values, errors }) => {
          useEffect(() => {
            setOrgId(+values.school.split('-')[1]);
          }, [values]);
          return (
            <>
              <ModalContent
                formInputs={formInputs.filter((formInput) => !formInput.hidden)}
                isLoading={createIsLoading}
                name='New Direct Message'
                extraClass='overflow-visible'
              />
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default NewChat;
